module.exports = __webpack_public_path__ + "static/media/bolsa.62195ba7.jpg";